module.exports = __webpack_public_path__ + "img/circle.7dff5062.svg";